export default {
  palette: {
    TRANSLUCENT: "rgba(255,255,255,0.3)",
    PRIMARY: "#342730",
    GREY_BG: "#f8f8f8",
    SECONDARY: "#0c3a5d",
    LIGHT_GREY: "#ccc",
    MEDIUM_GREY: "#aaa",
    DARK_GREY: "#666",
    LIGHT: "#ebf3f0",
    ACTIVE_HOVER: "#008bdb",
    HIGHLIGHT: "#f2f8fc",
    POSITIVE: "#8bc34a",
    NEGATIVE: "#ec1a3b",
    WARNING: "#ffc107",
    INFORMATION: "#90CAF9",
    BLACK: "#000",
    DARKGREY1: "#333",
    DARKGREY3: "#999",
    LIGHTGREY1: "#ddd",
    LIGHTGREY2: "#eee",
    LIGHTGREY3: "#EDEEEF",
    LIGHTGREY4: "#ccc",
    WHITE: "#FFF",
    HEADING: "#0c3a5d",
    SELECTED: "#00b5d3",
    ALTERNATIVE_ROW: "#eaf6ff",
    ACTIVE_LIGHT: "#eefdff",
    DISABLEDBORDER: "rgba(0, 0, 0, .1)"
  },
  border: {
    normal: color => `1px solid ${color}`
  },
  fontFamily: {
    BOLD: "cbm",
    REGULAR: "cb"
  },
  fontSize: {
    SMALL: "12px",
    MEDIUM: "14px",
    MEDIUM2: "16px",
    LARGE: "18px"
  }
};
